import { Grid, withStyles } from '@material-ui/core';
import classNames from 'classnames';
import * as React from 'react';

import LabelledButton from './LabelledButton';
import TnTypography from './tn-typography/TnTypography';

export interface IQuickActionProps {
  classes: any;
  isLabelled?: boolean;
  icons: Array<any>;
  activeButton?: string;
  justifyCenter?: boolean;
  disablelabel?: boolean;
  isJobDetails?: boolean;
}

export interface IQuickActionState {
  activeIcon: string;
}

class QuickActionButton extends React.Component<IQuickActionProps, IQuickActionState> {
  constructor(props: IQuickActionProps) {
    super(props);

    this.state = {
      activeIcon: '',
    };
  }

  displayIcons = () => {
    const { classes, icons, isJobDetails } = this.props;
    let iconList = icons.map((data) => data.icon);
    const keys = icons.map((icon) => icon.key);

    iconList = icons.map((iconObj, index) => {
      return (
        <Grid
          item
          key={keys[index]}
          className={classNames(iconObj.isDisabled === true && iconObj.disabledIcon === null && classes.hide)}
        >
          <Grid className={classes.labelledButtonWrapper} data-testid={iconObj.name + '_QuickActionButton'}>
            <LabelledButton
              borderRequired={iconObj.disabledIcon === null}
              label={this.props.disablelabel ? '' : iconObj.name}
              isActive={this.props.activeButton === keys[index]}
              isDisabled={iconObj.isDisabled}
              icon={iconObj.icon}
              circledIcon={iconObj.circledIcon}
              disabledIcon={iconObj.disabledIcon}
              isJobDetails={isJobDetails == true}
              onClick={() => {
                icons[index].onClick();
              }}
            ></LabelledButton>
            {this.props.disablelabel && (
              <TnTypography variant="caption2" className={classes.iconText}>
                {iconObj.name}
              </TnTypography>
            )}
          </Grid>
        </Grid>
      );
    });

    return iconList;
  };

  public render() {
    return (
      <Grid
        container
        direction="row"
        justify={this.props.justifyCenter ? 'center' : 'flex-start'}
        alignItems="center"
        spacing={2}
      >
        {this.displayIcons()}
      </Grid>
    );
  }
}

export default withStyles(() => ({
  fab: {
    boxShadow: 'none',
    backgroundColor: 'unset',
    height: '30px',
    width: '30px',
    marginRight: '9px',
  },
  hide: {
    display: 'none',
  },
  iconText: {
    textAlign: 'center',
    marginTop: 5,
  },
  labelledButtonWrapper: {
    minWidth: 35,
  },
}))(QuickActionButton);
